<form class="form-horizontal" [formGroup]="otherIncomeForm">
    <accordion-group [isOpen]="true">
        <span accordion-heading>
            <i class='fa fa-user'></i> Datos Generales
          </span>
          <div class="form-group row">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Tipo de Ingreso</b>
              <span appRequiredAsterisk [formGroup]="otherIncomeForm" controlName="incomeType"></span>
            </label>
            <div class="col-10 col-md-10 col-sm-8 ">
                <ng-select formControlName="incomeType" [items]="incomeTypes" bindLabel="value" bindValue="key" [readonly]="readonly"></ng-select>
              <!--  -->
            </div>
          </div> 
        <div class="form-group row">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Ingreso</b>
              <span appRequiredAsterisk [formGroup]="otherIncomeForm" controlName="incomeAmount"></span>
            </label>
            <div class="col-10 col-md-10 col-sm-8 ">
                <input type="number" class="form-control" formControlName="incomeAmount" [ngClass]="otherIncomeForm.controls.incomeAmount.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Especifique</b>
              <span appRequiredAsterisk [formGroup]="otherIncomeForm" controlName="specify"></span>
            </label>
            <div class="col-10 col-md-10 col-sm-8 ">
                <input type="text" class="form-control" formControlName="specify" [ngClass]="otherIncomeForm.controls.specify.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Fecha de Ingreso</b>
              <span appRequiredAsterisk [formGroup]="otherIncomeForm" controlName="receivingDate"></span>          
          </label>
            <div class="col-10 col-md-10 col-sm-8 ">
              <input bsDatepicker class="form-control" formControlName="receivingDate" [bsConfig]="{ isAnimated: true, containerClass:'theme-blue', displayOneMonthRange: true, selectFromOtherMonth:true }" [ngClass]="otherIncomeForm.controls.receivingDate.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
              <!--  -->
            </div>
          </div>
    </accordion-group>
</form>